import { useEffect, useState } from "react";
import { api } from "../lib/api";
import SiteCard from "../components/SiteCard";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";

export default function Sites() {
  const [sites, setSites] = useState([]);
  const [audits, setAudits] = useState([]);
  const [campagnes, setCampagnes] = useState([]);
  const [campagneId, setCampagneId] = useState("");

  useEffect(() => {
    api.get("/sites").then((res) => setSites(res.data));
    api.get("/campagnes").then((res) => {
      setCampagnes(res.data);
      const cross = res.data.find((c) => c.type_campagne === "CROSS_ASSESSMENT");
      if (cross) setCampagneId(cross.campagne_id);
    });
  }, []);

  useEffect(() => {
    if (campagneId) api.get("/audits", { params: { campagne_id: campagneId } }).then((res) => setAudits(res.data));
  }, [campagneId]);

  return (
    <div className="p-4 sm:p-6 max-w-6xl mx-auto space-y-5" data-testid="sites-page">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <h1 className="font-heading text-3xl font-black uppercase tracking-tight">Sites &amp; Usines</h1>
        <Select value={campagneId} onValueChange={setCampagneId}>
          <SelectTrigger className="w-56" data-testid="sites-campagne-select"><SelectValue placeholder="Campagne" /></SelectTrigger>
          <SelectContent>
            {campagnes.map((c) => <SelectItem key={c.campagne_id} value={c.campagne_id}>{c.nom}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {sites.map((site) => (
          <SiteCard key={site.site_id} site={site} audit={audits.find((a) => a.site_id === site.site_id)} />
        ))}
      </div>
    </div>
  );
}
